import { gsap, ScrollTrigger } from 'gsap/all';
import SplitText from "../__vendor/SplitText.min.js";


gsap.registerPlugin(ScrollTrigger);

const aboutMainSection = () => {
    const aboutMainSectionTl = gsap.timeline({
        paused: true
    });

    const text = new SplitText(".hero-about h1", { type: "chars" });

    gsap.set(".hero-about h1 > div", {
        opacity: 0,
        y: 15
    });


    aboutMainSectionTl.set('.hero-about', {
        className: "+= hero-about active",
    }, 0.1).to(text.chars, {
        autoAlpha: 1,
        y: 0,
        stagger: 0.015,
    }, 1)

    ScrollTrigger.create({
        scroller:'[data-scroll-container]',
        trigger: '.hero-about',
        start: 'top bottom-=200',
        end: 'bottom top',
        animation: aboutMainSectionTl,
        toggleActions: 'play none none none',
    });
};

export default aboutMainSection;